import { render, staticRenderFns } from "./JgCatalogGames.vue?vue&type=template&id=31815bc4&scoped=true&"
import script from "./JgCatalogGames.vue?vue&type=script&lang=ts&"
export * from "./JgCatalogGames.vue?vue&type=script&lang=ts&"
import style0 from "./JgCatalogGames.vue?vue&type=style&index=0&id=31815bc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31815bc4",
  null
  
)

export default component.exports